



























































import { Button, Container, SecondaryButton } from '../atoms'
import { Vue, Component } from 'vue-property-decorator'
import { Liff } from '../organisms'

interface ConsentData {
  partner?: string
  scopes?: Array<string>
}

interface ConsentContent {
  dynamic_content?: string
  short_name?: string
  full_name?: string
  logo_url?: string
  color?: string
  image_url?: string
  landing_url?: string
  permissions?: string
  consent?: string
}

@Component({
  components: {
    Container,
    Button,
    SecondaryButton,
    Liff
  }
})
export default class Consent extends Vue {
  public consentData: ConsentData = {}
  public consentContent: ConsentContent = {}
  public contentURL = process.env.VUE_APP_SCONTENT_URL || 'https://scontent.finnomena.com'
  public baseURL = process.env.VUE_APP_BASE_URL || 'https://auth.finnomena.com'
  public homeURL = process.env.VUE_APP_FINNO_ENDPOINT || 'https://www.finnomena.com'
  public accepted = false
  public companyLogoURL = `${this.contentURL}/auth/finnomena-funds-b.png`
  public displayTransition = false
  public displayLiff = false

  async mounted() {
    // url for testing http://localhost:3000/consent?challenge=x&data=eyJzY29wZXMiOlsib2ZmbGluZSIsIm9wZW5pZCIsImFjY291bnQiXSwicGFydG5lciI6ImJhY29uIn0
    try {
      if (typeof this.$route?.query?.data == 'string') {
        this.consentData = JSON.parse(atob(this.$route?.query?.data))
      }

      const resp = await fetch(`${this.contentURL}/auth/partners/${this.consentData.partner}/consent.json`)
      if (resp.status >= 400) {
        throw new Error(`ไม่สามารถแสดงข้อมูลได้ (status: ${resp.status})`)
      }

      this.consentContent = await resp.json()
    } catch (err) {
      const e = err as Error
      this.displayError(`ไม่สามารถแสดงข้อมูลได้ (${e.message})`)
    }
  }

  async cancel() {
    location.href = this.consentContent.landing_url ? this.consentContent.landing_url : this.homeURL
  }

  async accept() {
    const data = {
      accepted: true,
      challenge: this.$route?.query?.challenge
    }

    const resp = await fetch('/api/consent', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })

    const defaultErrorMessage = 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง'
    try {
      const result = await resp.json()
      if (resp.status > 400) {
        this.displayError(result.error || defaultErrorMessage)
      } else if (result && result.data && result.data.redirect_to) {
        this.accepted = true

        setTimeout(function () {
          location.href = result.data.redirect_to
        }, 2000)
      } else {
        throw new Error(resp.statusText)
      }
    } catch (err) {
      console.error(err)
      this.displayError(defaultErrorMessage)
    }
  }

  openLiff() {
    this.displayLiff = true
  }

  closeLiff() {
    this.displayLiff = false
  }

  displayError(msg: string) {
    location.href = `${this.baseURL}?error=${encodeURIComponent(msg)}`
  }
}
